import { Badge, Drawer, List, Menu, notification, Switch, Tooltip } from "antd";
import objectPath from "object-path";
import React, { useEffect, useMemo, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { TbBell, TbTriangleSquareCircle } from "react-icons/tb";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useLocalStorage from "use-local-storage";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import styled from "styled-components";
import io from "socket.io-client";
import fetchWrapper from "../../../../apsisEngine/helpers/fetchWrapper";
import { envProducer } from "../../../../apsisEngine/helpers/helpers";
const { SubMenu } = Menu;
// socketTotalUnseen = 0, socketNotifications = [], markAsRead, seenAll
export function Topbar({ handle }) {
  const history = useHistory();
  const { headerFooter, auth } = useSelector(
    ({ notification, auth }) => ({
      headerFooter: notification.headerFooter,
      auth: auth.coreModuleInfo,
    }),
    shallowEqual
  );
  const [socketNotifications, setSocketNotifications] = useState([]);
  const [socketTotalUnseen, setSocketTotalUnseen] = useState(0);
  const [darkAside, setDarkAside] = useLocalStorage("light-aside");

  const [open, setOpen] = useState(false);
  const [size, setSize] = useState("250px");
  const onClose = () => {
    setOpen(false);
  };
  const markAsRead = async (eventActionId) => {
    await fetchWrapper.post("apsisengine-notification/manager/mark-as-read", {
      eventActionIds: [eventActionId],
    });
  };

  const seenAll = async () => {
    await fetchWrapper.get("apsisengine-notification/manager/mark-as-all-read");
  };
  const openNotificationWithIcon = (type, title, message) => {
    notification[type]({
      message: title ?? "Title",
      description: message ?? "Description",
      placement: "topRight",
    });
  };

  useEffect(() => {
    const callSocket = () => {
      const user = JSON.parse(localStorage.getItem("AUTH"));
      const path = envProducer("public");
      if (user && user.access_token) {
        const socket = io(path, {
          query: {
            token: user.access_token,
          },
          transports: ["polling", "websocket"],
          secure: true,
        });
        socket.emit('notification', {
					event: 'notification',
					data: { test: true },
				});
        socket.on("notification", async (response) => {
          const res = JSON.parse(response);
          const { lastRecords, countTotalUnseen, notificationData } = res;
          if (notificationData) {
            openNotificationWithIcon(
              "success",
              notificationData.title,
              notificationData.message
            );
          }
          setSocketTotalUnseen(countTotalUnseen);
          if (lastRecords) {
            const eventActionIds = lastRecords.map((item) =>
              String(item.event_action_id)
            );
            eventActionIds?.length > 0 &&
              (await fetchWrapper.post(
                "/apsisengine-notification/manager/acknowledgement",
                {
                  eventActionIds,
                }
              ));
            const recordsData = lastRecords.map((item) => {
              return {
                title: item.message_subject,
                body: item.message_body,
                url: item?.action_url,
                status: item.notify_status,
                event_action_id: item.event_action_id,
                event_code: item?.event_code?.split("@")[0],
              };
            });
            setSocketNotifications(recordsData);
          }
        });
        socket.on("exception", function(data) {
          console.log("notification", data);
        });
        socket.on("disconnect", function() {
          console.log("Disconnected");
        });
      }
    };
    callSocket();
  }, []);

  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);

  const themeData = useMemo(() => {
    return headerFooter && JSON.parse(headerFooter?.color_json);
  }, [headerFooter]);

  useEffect(() => {
    if (darkAside == true) {
      document.documentElement.style.setProperty("--aside-bg-color", "#1e1e2d");
      document.documentElement.style.setProperty(
        "--aside-list-bg-color",
        "#1e1e2d"
      );
      document.documentElement.style.setProperty(
        "--aside-active-gradient",
        "linear-gradient(270deg, #DE6262 0%, #FFB88C 100%)"
      );
    } else {
      document.documentElement.style.setProperty(
        "--aside-bg-color",
        themeData?.aside_bg_color ?? "#0050b3"
      );
      document.documentElement.style.setProperty(
        "--aside-list-bg-color",
        themeData?.aside_list_bg_color ?? "#0078d4"
      );
      document.documentElement.style.setProperty(
        "--aside-active-gradient",
        themeData?.aside_active_gradient ??
          "linear-gradient(270deg, #004578 0%, #0078d4 100%)"
      );
      document.documentElement.style.setProperty(
        "--btn-primary",
        themeData?.primary ?? "#1890ff"
      );
      document.documentElement.style.setProperty(
        "--btn-secondary",
        themeData?.secondary ?? "#fff"
      );
      // document.documentElement.style.setProperty("--aside-bg-color", "#0050b3");
      // document.documentElement.style.setProperty(
      //   "--aside-list-bg-color",
      //   "#0078d4"
      // );
      // document.documentElement.style.setProperty(
      //   "--aside-active-gradient",
      //   "linear-gradient(270deg, #DE6262 0%, #FFB88C 100%)"
      // );
    }
  }, [darkAside, themeData]);

  function setAsideColor(bgColor, listColor, gradient) {
    document.documentElement.style.setProperty("--aside-bg-color", bgColor);
    document.documentElement.style.setProperty(
      "--aside-list-bg-color",
      listColor
    );
    document.documentElement.style.setProperty(
      "--aside-active-gradient",
      gradient
    );
  }

  return (
    <div className="topbar">


      <span
        style={{
          marginTop: "22px",
          cursor: "pointer",
          color: "rgba(0, 0, 0, 0.65)",
        }}
        className="mx-4 topbar-helper"
        onClick={() => {
          window.location.href = `${process.env.REACT_APP_ERP_FE}/faq/help`;
        }}
      >
        <AiOutlineInfoCircle
          style={{ fontSize: "18px" }}
          className="topbar-helper"
        />{" "}
        Help
      </span>

      {/* <span style={{ marginTop: "12px", cursor: "pointer" }}>
        <Dropdown>
          <Dropdown.Toggle
            variant=""
            style={{ color: "rgba(0, 0, 0, 0.65)" }}
            className="topbar-helper"
          >
            <MdOutlineNoteAlt
              style={{ fontSize: "18px", color: "rgba(0, 0, 0, 0.65)" }}
              className="topbar-helper"
            />{" "}
            My Requisition
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_ERP_FE}/supply-chain/my-requisition`;
              }}
            >
              <AiOutlineGroup
                style={{
                  marginTop: "1px",
                  fontSize: "16px",
                  marginRight: "5px",
                }}
              />{" "}
              Stock Requisition
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_ERP_FE}/procurement/purchase-requisition`;
              }}
            >
              <AiOutlineGroup
                style={{
                  marginTop: "1px",
                  fontSize: "16px",
                  marginRight: "5px",
                }}
              />{" "}
              Purchase Requisition
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </span> */}

      {/* <span
        style={{
          marginTop: "22px",
          cursor: "pointer",
          color: "rgba(0, 0, 0, 0.65)",
        }}
        className="mx-4 topbar-helper"
        onClick={() => {
          window.location.href = `${process.env.REACT_APP_ERP_FE}/cc_viewer`;
        }}
      >
        <TbTriangleSquareCircle
          style={{ fontSize: "18px", color: "rgba(0, 0, 0, 0.65)" }}
          className="topbar-helper"
        />{" "}
        CC Viewer
      </span> */}

      <span
        style={{
          marginTop: "22px",
          cursor: "pointer",
          color: "rgba(0, 0, 0, 0.65)",
        }}
        className="mx-4 topbar-helper"
        onClick={() => {
          // window.location.href = `${process.env.REACT_APP_ERP_FE}/delegation`;
          history.push("/delegation/pending-approval");
        }}
      >
        <TbTriangleSquareCircle
          style={{ fontSize: "18px", color: "rgba(0, 0, 0, 0.65)" }}
          className="topbar-helper"
        />{" "}
        Pending Approval
      </span>

      {layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />}

      {/*<span
        style={{
          fontSize: "25px",
          marginTop: "10px",
          cursor: "pointer",
          marginRight: "25px",
        }}
        onClick={handle.active ? handle.exit : handle.enter}
      >
        <AiOutlineFullscreen />
      </span>*/}


      <Menu mode="horizontal" style={{ marginTop: "8px" }}>
        <Menu.SubMenu
          title={
            <Badge count={socketTotalUnseen}>
              <span className="submenu-title-wrapper">
                <TbBell style={{ fontSize: "20px", color: "#111" }} />
              </span>
            </Badge>
          }
          key="notifications"
        >
          <Menu.Item
            key="notification-list"
            className="p-0 bg-transparent"
            style={{ height: "auto", width: "400px" }}
          >
            <List
              className="header-notifications"
              itemLayout="horizontal"
              dataSource={socketNotifications}
              footer={
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ marginTop: "auto", paddingLeft: '10px', paddingRight: '10px' }}
                >
                  {socketTotalUnseen} Notifications{" "}
                  <span className="seen-all" onClick={seenAll}>
                    Seen All
                  </span>
                </div>
              }
              renderItem={(item) => (
                <Notification
                  onClick={() => {
                    markAsRead(String(item.event_action_id));
                    window.open(`${item.url}&type=${item.event_code}`);
                  }}
                >
                  <List.Item>
                    <List.Item.Meta
                      title={item.title}
                      description={
                        <div className="description">
                          <span>{item.body}</span>
                          {item.status !== "Seen" && (
                            <Tooltip title="Mark as Seen">
                              <i className="fa fa-circle fa-lg"></i>
                            </Tooltip>
                          )}
                        </div>
                      }
                    />
                  </List.Item>
                </Notification>
              )}
            />
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
      <Drawer
        title={`Settings2`}
        placement="right"
        size={size}
        onClose={onClose}
        open={open}
        width={"300px"}
      >
        <div className="row">
          <div className="col-md-12 mb-4">
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0" style={{ fontSize: "14px" }}>
                Dark sidebar menu
              </p>
              <Switch
                defaultChecked={darkAside == true ? true : false}
                size="small"
                onChange={(val) => {
                  setDarkAside(true);
                  if (val) {
                    setAsideColor(
                      "#1e1e2d",
                      "#1e1e2d",
                      "linear-gradient(270deg, #DE6262 0%, #FFB88C 100%)"
                    );
                  } else {
                    setAsideColor(
                      "#0050b3",
                      "#0078d4",
                      "linear-gradient(270deg, #DE6262 0%, #FFB88C 100%)"
                    );
                  }
                }}
              />
            </div>
          </div>
          {/* <div className="col-md-12">
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0" style={{ fontSize: "14px" }}>
                Weak colors
              </p>
              <Switch
                size="small"
                defaultChecked={theme == "dark" ? true : false}
                onChange={(val) => {
                  switchTheme();
                }}
              />
            </div>
          </div> */}
        </div>
      </Drawer>

      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}
const Notification = styled.div`
  .ant-list-item {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;
